module.exports = __webpack_public_path__ + "static/img/ban.a7d1e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ban.png
// module id = +sSX
// module chunks = 1